/* One class per indicator state, mapped by literal keys in FormField.molecule.vue. */
.indicator-unfilled {
  background-color: var(--color-ds-indicator-neutral);
}

.indicator-prefilled {
  background-color: var(--color-ds-warning);
}

.indicator-valid {
  background-color: var(--color-ds-success);
}

.indicator-invalid {
  background-color: var(--color-ds-danger);
}

.indicator-server-error {
  background-color: var(--color-ds-danger-hover);
}
